import { useEffect, useState } from "react";
import AddUpdateEngineer from "./AddUpdateEngineer";
import MainBody from "../../component/MainBody";
import httpRequest from "../../utils/Http";
import { AutoSizer, List } from "react-virtualized";
import "react-virtualized/styles.css";
import Switch from "../../component/Switch";
import { toast } from "react-toastify";

const EngineersList = () => {
  const [formData, setFormData] = useState({});
  const [reloadList, setReload] = useState(true);
  const [engineerList, setEngineerList] = useState([]);

  useEffect(() => {
    (async () => {
      if(reloadList){
        setReload(false)
        const listdata = await httpRequest(`getengineerlist`, {}, "GET");
        if (listdata.status === true && listdata.data) {
          setEngineerList(listdata.data);
          
          
        } else {
          setEngineerList([]);
        }
      }

    })();
  }, [reloadList]);

    const updateToggleHandler = async (agent_id, value) => {
    try {
      setReload(false);
      let postData = {
        agent_id,
        active: value === true ? 1 : 0,
      };
      const data = await httpRequest("updateagentstatus", postData, "POST");

      if (data.status === true && data.message) {
        setReload(true);

        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {}
  };

  const rowRenderer = ({ index, key, style }) => {
    const user = engineerList[index];

    return (
      <div
        key={key}
        style={style}
        className="row py-2 border-bottom align-items-center"
      >
        <div className="col-12 col-sm-3 fw-medium">{user.name}</div>
        <div className="col-12 col-sm-2">{user.mobile_number}</div>
        <div className="col-12 col-sm-3 text-break">{user.email}</div>
        <div className="col-12 col-sm-2">        <Switch
          isOn={Number(user.active) === 1 ? true : false}
          id={user.agent_id}
          handleToggle={(e) => {
            updateToggleHandler(user.agent_id, e.target.checked);
          }}
          onColor="#EF476F"
        /></div>
        <div className="col-12 col-sm-2">
          <button
            className="btn btn-primary btn-sm mt-2 mt-sm-0"
            data-toggle="modal"
            data-target="#modal-addengineer"
            onClick={() =>
              setFormData({
                agent_id: user.agent_id,
                name: user.name,
                mobile_number: user.mobile_number,
                email: user.email,
                sf_id: user.entity_id,
              })
            }
          >
            Edit
          </button>
        </div>
      </div>
    );
  };

  return (
    <MainBody
      breadcrumbTitle={"Engineer"}
      breadcrumbSubTitle={""}
      navButton={""}
      title={""}
      component={
        <section className="content" style={{ padding: "10px" }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Add Engineers</h3>
                  <div className="card-tools">
                    <button type="button" className="btn btn-sm btn-primary"  data-toggle="modal"
            data-target="#modal-addengineer">Add Engineer</button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row fw-bold border-bottom py-2 d-none d-sm-flex">
                    <div className="col-sm-3">
                      <th>Name</th>
                    </div>
                    <div className="col-sm-2">
                      <th>Mobile</th>
                    </div>
                    <div className="col-sm-3">
                      <th>Email</th>
                    </div>
                    <div className="col-sm-2">
                      <th>Action</th>
                    </div>
                  </div>
                  <div style={{ height: "500px" }}>
                    <AutoSizer>
                      {({ width, height }) => (
                        <List
                       
                          key={engineerList.length} // Forces List to rerender
                          width={width}
                          height={height}
                          rowCount={engineerList.length}
                          rowHeight={80}
                          rowRenderer={rowRenderer}
                        />
                      )}
                    </AutoSizer>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AddUpdateEngineer
            formData={formData}
            setFormData={setFormData}
            setReload={setReload}
          />
        </section>
      }
    />
  );
};

export default EngineersList;
